<script setup lang="ts">
import { useComponentClasses } from "../../composables";

interface ModalTitleProps {
  /** ID of the title element - effectively for the aria-labelledby attribute */
  id?: string;
}

const { id } = defineProps<ModalTitleProps>();

const { root } = useComponentClasses("ui-modal-title");

const rootClass = root();
</script>

<template>
  <h3 :class="rootClass" :id>
    <slot />
  </h3>
</template>

<style scoped>
.ui-modal-title {
  color: var(--ui-color-text);
  font-size: var(--ui-font-size-lg);
  font-weight: var(--ui-font-weight-medium);
  line-height: var(--ui-line-height-normal, 1.5rem);
}
</style>
